import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
    providedIn: "root"
})
export class PiValidatorsService {
    piList = null;
    message = null;

    constructor(private translate: TranslateService) {
    }

    setNames(list) {
        this.piList = list;
    }

    validate(startDate) {
      if (!startDate) {
        this.message = this.translate.instant("ERRORS.SELECT_POLICY_YEAR_FIRST");
      } else {
        this.validateParticipatingInsurers(startDate);
      }
      return !this.message;
    }

    
    GetPiByName = function(piName, defaultUrl) {
        const pis = this.piList;
        const piLower = piName.toLowerCase();

        let result = pis[pis.length - 1];
        result.Url = defaultUrl;

        for (let i = 0, len = pis.length; i < len; i++) {
            const piLowerCurrent = pis[i].Name.toLowerCase();

            if (piLower === piLowerCurrent || piLower + "-2016" === piLowerCurrent) {
                result = pis[i];
            }
        }
        return result;
    };

    private validateParticipatingInsurers(proposedPiValue) {
        const possibleValues = this.piList;

        // Allows an empty string because the field is not required.
        if (proposedPiValue && !this.isInList(possibleValues, proposedPiValue.trim())
            && proposedPiValue.trim() !== this.translate.instant("GLOBAL.OTHER")) {
            this.message = "Sorry, the participating insurer " + proposedPiValue.trim() + " is invalid.";
        } else if (!proposedPiValue) {
            this.message = this.translate.instant("ERRORS.COMPLETE_REQUIRED_FIELDS");
        }
    }

    private isInList(validValues, value) {
        return (validValues.indexOf(value) > -1 || validValues.indexOf(value + "-2016") > -1);
    }

}
